import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'

import MaterialSelectPage from '@/components/model-select-page/MaterialSelectPage.vue'
import ModelSelectPage from '@/views/configurator/ModelSelectPage.vue'
import ConfiguratorPage from '@/views/configurator/ConfiguratorPage.vue'
import TermsOfService from '@/views/information/TermsOfService.vue'
import PrivacyPolicy from '@/views/information/PrivacyPolicy.vue'
import AboutUs from '@/views/information/AboutUs.vue'
import NotFoundPage from '@/views/information/NotFoundPage.vue'
import OrderConfirmation from '@/views/information/OrderConfirmation.vue'
import ContactPage from '@/views/information/ContactPage.vue'

// CMS
import AuthPage from '@/views/cms/AuthPage.vue'
import ForgotPassword from '@/views/cms/ForgotPassword.vue'
import ResetPassword from '@/views/cms/ResetPassword.vue'
import CmsPage from '../views/cms/CMSPage.vue';
import CmsDashboard from '@/views/cms/sections/management/CmsDashboard.vue'
import CmsOrders from '@/views/cms/sections/management/CmsOrders.vue'
import CmsTrailers from '@/views/cms/sections/trailers/CmsTrailers.vue'
import CmsTrailerGroups from '@/views/cms/sections/trailers/CmsTrailerGroups.vue'
import CmsAddons from '@/views/cms/addons/CmsAddonsSection.vue'
import CmsAddonsForModelsSection from '@/views/cms/addons/CmsAddonsForModelsSection.vue'
import CmsTexts from '@/views/cms/sections/texts/CmsTexts.vue'
import CmsSettings from '@/views/cms/sections/settings/CmsSettings.vue'

const routes = [
  { path: '/', component: MaterialSelectPage },
  { path: '/models', component: ModelSelectPage },
  { path: '/configurator', component: ConfiguratorPage },
  { path: '/terms-of-service', component: TermsOfService },
  { path: '/privacy-policy', component: PrivacyPolicy },
  { path: '/about-us', component: AboutUs },
  { path: '/contact', component: ContactPage },
  { path: '/order-confirmation', component: OrderConfirmation },

  // CMS
  { path: '/cms/login', component: AuthPage },
  { path: '/cms/forgot-password', component: ForgotPassword },
  { path: '/cms/reset-password/:token', component: ResetPassword },
  { path: '/password-reset/:token', component: ResetPassword },
  {
    path: '/cms',
    component: CmsPage,
    meta: { requiresAuth: true },
    children: [
      { path: 'dashboard', component: CmsDashboard },
      { path: 'orders', component: CmsOrders },
      { path: 'trailers', component: CmsTrailers },
      { path: 'trailer-groups', component: CmsTrailerGroups },
      { path: 'addons', component: CmsAddons },
      { path: 'model-addons', component: CmsAddonsForModelsSection },
      { path: 'texts', component: CmsTexts },
      { path: 'settings', component: CmsSettings },
      { path: '', redirect: '/cms/dashboard' },
    ]
  },

  // 404
  { path: '/404', name: 'NotFound', component: NotFoundPage },

  // catch all -> redirect na /404
  { path: '/:pathMatch(.*)*', redirect: '/404' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' }
  }
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  const isLoginPage = to.path === '/cms/login'
  const isForgotPage = to.path === '/cms/forgot-password'
  const isResetPage = to.path.startsWith('/cms/reset-password') || to.path.startsWith('/password-reset')

  const isCmsRoute = to.path.startsWith('/cms') && !isLoginPage && !isForgotPage && !isResetPage

  if (authStore.user === null && isCmsRoute) {
    try {
      await authStore.fetchUser()
    } catch (err) {
      console.warn('[router] fetchUser() nie powiodło się – brak aktywnej sesji lub błąd:', err)
    }
  }

  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    next('/cms/login')
  } else if ((isLoginPage || isForgotPage || isResetPage) && authStore.isLoggedIn) {
    next('/cms')
  } else {
    next()
  }
})

export default router
